import * as type from '../../constants';

const initialState = {
    userList: null,
    updateLoader: false,
    loading: false,
    error: null,
}

export function deleteRequest(state = initialState, action) {
    switch (action.type) {
        case type.GET_DELETE_REQ_USERS_LIST:
            return {
                ...state,
                loading: true,
            }
        case type.GET_DELETE_REQ_USERS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                userList: action.userList
            }
        case type.GET_DELETE_REQ_USERS_LIST_FALIURE:
            return {
                ...state,
                loading: false,
                error: action.message,
            }

        case type.RECOVER_ACCOUNT:
            return {
                ...state,
                updateLoader: true,
            }
        case type.RECOVER_ACCOUNT_SUCCESS:
            return {
                ...state,
                updateLoader: false,
            }
        case type.RECOVER_ACCOUNT_FALIURE:
            return {
                ...state,
                updateLoader: false,
                error: action.message,
            }

        case type.DELETE_ACCOUNT_PERMENENTLY:
            return {
                ...state,
                updateLoader: true,
            }
        case type.DELETE_ACCOUNT_PERMENENTLY_SUCCESS:
            return {
                ...state,
                updateLoader: false,
            }
        case type.DELETE_ACCOUNT_PERMENENTLY_FALIURE:
            return {
                ...state,
                updateLoader: false,
                error: action.message,
            }
        default:
            return state
    }
}